import { render, staticRenderFns } from "./pdfLook.vue?vue&type=template&id=6287d37c&scoped=true"
import script from "./pdfLook.vue?vue&type=script&lang=js"
export * from "./pdfLook.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6287d37c",
  null
  
)

export default component.exports